import { render, staticRenderFns } from "./scroll.vue?vue&type=template&id=42947e5d&scoped=true&"
import script from "./scroll.vue?vue&type=script&lang=js&"
export * from "./scroll.vue?vue&type=script&lang=js&"
import style0 from "./scroll.vue?vue&type=style&index=0&id=42947e5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42947e5d",
  null
  
)

export default component.exports